import { Injectable } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
// import { ApiService } from './api.service';
import { UserModel } from '../model/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  
  // jwtHelper = new JwtHelperService();
  decodedToken: any;
  //  currentUser: User;
  photoUrl = new BehaviorSubject<string>('./assets/user.png');
  currentPhotoUrl = this.photoUrl.asObservable();

  constructor() { }
  loggedIn(): boolean {

    //debugger
    const token = localStorage.getItem('token');
    return !!token;
    //return true;
  }


}
